import { useTranslation } from 'react-i18next';

import { TurnIssue } from './buildTurnIssues';
import { TooltipStepLink } from './DetailsRow';
import { SummaryRow, SummarySection } from './SummaryRows';
import { useGoToWebhookPage, useWebhookName } from '../../../hooks/useWebhookLink';

const NAME_SLOT = '\u0000';

const WebhookIssueText = ({ webhookId, fallback }: { webhookId: string; fallback: string }) => {
  const { t } = useTranslation();
  const name = useWebhookName(webhookId);
  const link = useGoToWebhookPage(webhookId);

  if (!name) {
    return <span>{fallback}</span>;
  }

  const [before, after = ''] = t('try_it.turn_issues.webhook_failed_named', { 0: NAME_SLOT }).split(
    NAME_SLOT
  );

  return (
    <span>
      {before}
      <TooltipStepLink link={link} tooltip={t('try_it.details.go_to_webhook')}>
        {name}
      </TooltipStepLink>
      {after}
    </span>
  );
};

export const TurnIssues = ({ issues }: { issues: TurnIssue[] }) => {
  const { t } = useTranslation();

  return (
    <SummarySection title={t('try_it.turn_issues.title')}>
      {issues.map((issue, index) => (
        <SummaryRow key={issue.key} tone={issue.severity} isLast={index === issues.length - 1}>
          {issue.webhookId ? (
            <WebhookIssueText webhookId={issue.webhookId} fallback={issue.text} />
          ) : (
            <span>{issue.text}</span>
          )}
          {issue.detail && <span>· {issue.detail}</span>}
        </SummaryRow>
      ))}
    </SummarySection>
  );
};
